/**
 * Labstep
 *
 * @module components/Molecule/Card/EmptyState
 * @desc Molecule Empty State card
 */

import type React from 'react';
import styles from './styles.module.scss';
import type { MoleculeCardEmptyStateProps } from './types';

export const MoleculeCardEmptyState: React.FC<
  MoleculeCardEmptyStateProps
> = ({ action }) => (
  <div className={styles.container}>
    <div>{action}</div>
  </div>
);
